<template>
    <div class="stacked-bar-wrapper">
        <Chart
            type="bar"
            :data="chartData"
            :options="chartOptions"
            class="h-full w-full"
        />
    </div>
</template>

<script>
import SafeChart from '@/components/SafeChart.vue';

export default {
    name: 'StackedBarChart',
    components: {
        Chart: SafeChart
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        colorMap: {
            type: Object,
            required: true
        }
    },
    computed: {
        chartData() {
            if (!this.data || !this.data.datasets) return {};

            const datasets = this.data.datasets;
            const numCols = this.data.labels?.length || 0;

            // Para cada coluna, descobre qual é o último dataset com valor > 0
            // (o que fica visualmente no topo da pilha)
            const topDatasetPerCol = Array(numCols).fill(-1);
            for (let col = 0; col < numCols; col++) {
                for (let ds = datasets.length - 1; ds >= 0; ds--) {
                    const val = datasets[ds].data?.[col];
                    if (val != null && val > 0) {
                        topDatasetPerCol[col] = ds;
                        break;
                    }
                }
            }

            const mapped = datasets.map((ds, dsIdx) => {
                const color = this.colorMap[ds.label] || '#9CA3AF';

                // borderRadius por célula: array com um valor por coluna
                const borderRadius = Array(numCols).fill(0).map((_, col) => {
                    if (topDatasetPerCol[col] === dsIdx) {
                        // Topo da coluna: arredonda apenas os cantos superiores
                        return { topLeft: 5, topRight: 5, bottomLeft: 0, bottomRight: 0 };
                    }
                    return 0; // meio ou base: reto em todos os lados
                });

                return {
                    ...ds,
                    backgroundColor: color,
                    borderColor: 'transparent',
                    borderWidth: 0,
                    borderRadius,
                    borderSkipped: false,
                    barPercentage: 0.5,
                    categoryPercentage: 0.8
                };
            });

            return { ...this.data, datasets: mapped };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            color: '#9ca3af',
                            usePointStyle: true,
                            pointStyle: 'circle',
                            padding: 16,
                            font: { size: 11 }
                        }
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        backgroundColor: 'rgba(15, 23, 42, 0.9)',
                        titleColor: '#fff',
                        bodyColor: '#e2e8f0',
                        cornerRadius: 8,
                        padding: 10
                    }
                },
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false,
                            drawBorder: false
                        },
                        ticks: {
                            color: '#94a3b8',
                            font: {
                                size: 11
                            }
                        }
                    },
                    y: {
                        stacked: true,
                        grid: {
                            color: 'rgba(148, 163, 184, 0.1)',
                            drawBorder: false
                        },
                        ticks: {
                            color: '#94a3b8',
                            font: {
                                size: 11
                            }
                        }
                    }
                },
                interaction: {
                    mode: 'nearest',
                    axis: 'x',
                    intersect: false
                }
            };
        }
    }
}
</script>

<style scoped>
.stacked-bar-wrapper {
    height: 250px; /* Altura padrão, ajustável via flex no pai */
    width: 100%;
}
</style>
